import { render, staticRenderFns } from "./goodSerieslist.vue?vue&type=template&id=5124ab57&scoped=true&"
import script from "./goodSerieslist.vue?vue&type=script&lang=js&"
export * from "./goodSerieslist.vue?vue&type=script&lang=js&"
import style0 from "./goodSerieslist.vue?vue&type=style&index=0&id=5124ab57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124ab57",
  null
  
)

export default component.exports